// extracted by mini-css-extract-plugin
export var chip = "_a0-0";
export var filterDropdown = "_a0-5";
export var filterItem = "_a0-6";
export var icon = "_a0-1";
export var removeButton = "_a0-3";
export var removeIcon = "_a0-4";
export var separator = "_a0-2";